<!-- dashboard.component.html -->
<div class="flex flex-col h-screen">
  <!-- Header -->
  <div
    class="flex flex-wrap gap-4 items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
    <div class="flex-1">
      <p-breadcrumb class="max-w-full" [home]="home" />
    </div>
  </div>

  <!-- Admin Area Explanation Cards -->
  <div class="flex-1 overflow-auto p-6">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <p-card header="Benutzerverwaltung" styleClass="h-full">
        <ng-template pTemplate="content">
          <p>
            Verwalten Sie Benutzerkonten, Rollen und Berechtigungen. Hier können Sie neue Benutzer hinzufügen,
            bestehende bearbeiten oder entfernen.
          </p>
        </ng-template>
      </p-card>
      <p-card header="Datenanalyse" styleClass="h-full">
        <ng-template pTemplate="content">
          <p>
            Analysieren Sie wichtige Kennzahlen und erhalten Sie Einblicke in die Nutzung der Plattform. Nutzen Sie die
            bereitgestellten Berichte für fundierte Entscheidungen.
          </p>
        </ng-template>
      </p-card>
      <p-card header="Systemeinstellungen" styleClass="h-full">
        <ng-template pTemplate="content">
          <p>
            Passen Sie Systemeinstellungen an, konfigurieren Sie Integrationen und verwalten Sie Benachrichtigungen für
            das gesamte System.
          </p>
        </ng-template>
      </p-card>
    </div>
  </div>
</div>